$box-padding-desktop-l: 48px !default;
$box-padding-desktop: 40px !default;
$box-padding-tablet: 32px !default;
$box-padding-mobile: 24px !default;
$box-border-width: 0 !default;
$box-border-radius: 0 !default;

:host {
  display: block;
  @include slotted-margins("*:not([slot])");
}

.#{$prefix}box {
  background-color: v(backgroundColor);
  padding: $box-padding-desktop-l;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  border-width: $box-border-width;
  border-radius: $box-border-radius;
  border-style: solid;
  border-color: v(borderColor);

  &.#{$prefix}horizontal-alignment {
    &-center {
      align-items: center;
      text-align: center;
    }

    &-right {
      align-items: flex-end;
      text-align: right;
    }
  }

  &.#{$prefix}vertical-alignment {
    &-center {
      justify-content: center;
    }

    &-bottom {
      justify-content: flex-end;
    }
  }

  @include for-size(desktop) {
    padding: $box-padding-desktop;
  }

  @include for-size(tablet) {
    padding: $box-padding-tablet;
  }

  @include for-size(phone) {
    padding: $box-padding-mobile;
  }

  &.#{$prefix}active {
    border-color: v(activeBorderColor);
    background-color: v(activeBackgroundColor);
  }
}
